import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  register: (name, email, password) =>
    apiClient.post("/auth/register", { name, email, password }),
  login: (email, password) =>
    apiClient.post("/auth/login", { email, password }),
};

export const taskService = {
  getTasks: (status) => apiClient.get("/tasks", { params: { status } }),
  getTask: (id) => apiClient.get(`/tasks/${id}`),
  createTask: (title, description, status) =>
    apiClient.post("/tasks", { title, description, status }),
  updateTask: (id, title, description, status) =>
    apiClient.put(`/tasks/${id}`, { title, description, status }),
  deleteTask: (id) => apiClient.delete(`/tasks/${id}`),
};

export default apiClient;
